import {Box, Button, SxProps, Typography} from "@mui/material";
import ChevronLeftIcon from "assets/icons/ChevronLeft";
import {useLocation, useNavigate, useOutletContext} from "react-router-dom";
import {MaterialContextProps} from "pages/Material/types";

const BackButton = ({sx}: {sx?: SxProps}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const {setSelectedSubcategory, setSelectedCategory, setMixedFilterValue, setSelectedKeywords, setKeywordsFilter} = useOutletContext<MaterialContextProps>()

  const clearAllFilters = () => {
    setSelectedCategory(null);
    setSelectedSubcategory('');
    setMixedFilterValue(null);
    setSelectedKeywords([]);
    setKeywordsFilter([])
  }

  const handleClick = () => {
    clearAllFilters()
    navigate(`/${location.pathname.split('/')[1]}`)
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center',
        textTransform: 'none',
        padding: 0,
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'transparent',
          '& .MuiIconButton-root': {
            backgroundColor: 'primary.dark',
          }
        },
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: 2,
          backgroundColor: 'primary.main',
          mr: 2,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ChevronLeftIcon sx={{color: 'white'}}/>
      </Box>
      <Typography variant="body2" sx={{opacity: 0.7}}>
        Все материалы
      </Typography>
    </Button>
  )
}

export default BackButton
